import { render, staticRenderFns } from "./recycleBin.vue?vue&type=template&id=289b69d6&scoped=true"
import script from "./recycleBin.vue?vue&type=script&lang=js"
export * from "./recycleBin.vue?vue&type=script&lang=js"
import style0 from "./recycleBin.vue?vue&type=style&index=0&id=289b69d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289b69d6",
  null
  
)

export default component.exports